/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { SVBButton } from '@svb/svb-react-components';
import { regenTokenifExpired } from '../../helpers/utilityFunctions';

export default function HealthCheckPage(props) {
  // const tokenToUse = props?.token;
  const [retestDateTime, setRetestDateTime] = useState(0);
  const [token, setToken] = useState(false);
  const [tokenMsg, setTokenMsg] = useState('in progress...');
  //
  const [browse, setbrowse] = useState(false);
  const [browseMsg, setbrowseMsg] = useState('in progress...');
  //
  const [content, setcontent] = useState(false);
  const [contentMsg, setcontentMsg] = useState('in progress...');
  const requestContent =
    process.env.REACT_APP_CONTENT_SERVER +
    '/portal-content?resourcePath=/apis/ach-transfers/1.3&resourceName=config.json';

  let clientID = process.env.REACT_APP_CLIENT_ID || '';
  let apigeeHost = process.env.REACT_APP_APIGEE_HOST || '';
  const baseUrl = window.location.host;
  // Assign default ID and host
  // Assign based on URL
  if (baseUrl.includes('localhost')) {
    clientID = process.env.REACT_APP_LOCAL_CLIENT_ID;
    apigeeHost = process.env.REACT_APP_LOCAL_APIGEE_HOST;
  } 

  const resetRetestDateTime = () => {
    const cDateTime = new Date();
    setRetestDateTime(cDateTime.toString());
  };
  const retestOnClick = () => {
    setTokenMsg('in progress...');
    setbrowseMsg('in progress...');
    setcontentMsg('in progress...');
    checkOnlineStatus('token');
    checkOnlineStatus('browse');
    checkOnlineStatus('content');
    resetRetestDateTime();
  };
  /* eslint-enable */
  const checkOnlineStatus = async (key) => {
    // build token request
    // token headers
    let tokenHeaders = new Headers();
    tokenHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
    // token body params
    let tokenUrlencoded = new URLSearchParams();
    tokenUrlencoded.append('grant_type', 'urn:svb:params:oauth:grant-type:anonymous');
    tokenUrlencoded.append('client_id', clientID);
    // token request-options
    let tokenrequestOptions = {
      method: 'POST',
      headers: tokenHeaders,
      body: tokenUrlencoded,
    };

    // build browse request
    // browse headers
    let browseHeaders = new Headers();
    const anontoken = await regenTokenifExpired();
    browseHeaders.append('Authorization', `Bearer ${anontoken}`);
    // browse request
    let browseRequestOptions = {
      method: 'GET',
      headers: browseHeaders,
    };
    // build content-svc request
    // content-svc headers
    let contentSvcHeaders = new Headers();
    contentSvcHeaders.append('Authorization', `${anontoken}`);
    let contentRequestOptions = {
      headers: contentSvcHeaders,
    };
    try {
      switch (key) {
        case 'browse':
          await fetch(
            `${apigeeHost}${process.env.REACT_APP_APIGEE_CATALOG_PATH}`,
            browseRequestOptions,
          )
            .then((data) => {
              setbrowseMsg(data?.message || data?.status);
              setbrowse(data.status >= 200 && data.status < 300);
            })
            .catch((err) => {
              setbrowseMsg(JSON.stringify(err, true));
              setbrowse(err.status >= 200 && err.status < 300);
            });

          break;
        case 'content':
          await fetch(`${requestContent}`, contentRequestOptions)
            .then((data) => {
              setcontentMsg(data?.message || data?.status);
              setcontent(data.status >= 200 && data.status < 300);
            })
            .catch((err) => {
              setcontentMsg(JSON.stringify(err, true));
              setcontent(err.status >= 200 && err.status < 300);
            });

          break;
        case 'token':
          await fetch(`${apigeeHost}${process.env.REACT_APP_TOKEN_PATH}`, tokenrequestOptions)
            .then((data) => {
              setTokenMsg(data?.message || data?.status);
              setToken(data.status >= 200 && data.status < 300);
            })
            .catch((err) => {
              setTokenMsg(JSON.stringify(err, true));
              setToken(err.status >= 200 && err.status < 300);
            });

          break;
      }
    } catch (err) {
      switch (key) {
        case 'browse':
          setbrowseMsg(JSON.stringify(err, true));
          setbrowse(false);
          break;
        case 'content':
          setcontentMsg(JSON.stringify(err, true));
          setcontent(false);
          break;
        case 'token':
          setTokenMsg(JSON.stringify(err, true));
          setToken(false);
          break;
      }
    }
  };
  useEffect(() => {
    checkOnlineStatus('token');
    checkOnlineStatus('browse');
    checkOnlineStatus('content');
    resetRetestDateTime();
  }, []);

  return (
    <div className='container' id='apis-health-status'>
      <div className='row'>
        <section className='mt-5 mb-5 p-5 apis-health-status-content'>
          <h1>APIs Health Status </h1>
          <h5>Last tested at: {retestDateTime}</h5>
          <SVBButton
            text='Re-test'
            size='large'
            style='primary'
            state='default'
            type='text'
            onClick={() => {
              retestOnClick();
            }}
          />
          <div className='table-responsive mt-4'>
            <table className='table table-striped'>
              <thead>
                <tr>
                  <th>API SERVICES</th>
                  <th>STATUS</th>
                  <th>RESPONSE</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Tokens API</td>
                  <td>{`${token ? 'ONLINE' : 'OFFLINE'}`}</td>
                  <td>{tokenMsg}</td>
                </tr>
                <tr>
                  <td>Browse API</td>
                  <td>{`${browse ? 'ONLINE' : 'OFFLINE'}`}</td>
                  <td>{browseMsg}</td>
                </tr>
                <tr>
                  <td>Contents API</td>
                  <td>{`${content ? 'ONLINE' : 'OFFLINE'}`}</td>
                  <td>{contentMsg}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  );
}
